import update from 'immutability-helper';
import {
  GET_AUNTIES_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  aunties: [],
};

const communities = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUNTIES_SUCCESS:
      return update(state, {
        aunties: {
          $set: action.payload.data,
        },
      });
    default:
      return state;
  }
};

export default communities;
